import { Component, OnInit } from '@angular/core';

/**
 * Base component for Code verification,
 * In the normal flow, the Code verification component will be displayed in this component
 * This will not comes to play in the case of Marketo
 */
@Component({
	selector: 'app-base-code-verification',
	templateUrl: './base-code-verification.component.html',
})
export class BaseCodeVerificationComponent {}
